import React, { useState } from "react";

import IconButton from "@material-ui/core/IconButton";
import Drawer from "@material-ui/core/Drawer";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";

import TopBar from "./Topbar"
import Menu from "./Menu";
import ContactInfo from "./ContactInfo";
import LanguageSwitch from "./LanguageSwitch";
import logo from "../../assets/images/prom-opecs-logo.png";

const Header = ({ setLocale }) => {
    const [, setLang] = useState('ua');
    const [mobileOpen, setMobileOpen] = useState(false);
    const isCompact = useMediaQuery('(max-width:959.95px)');

    const handleLangChange = (newLang) => {
        setLang(newLang);
        setLocale(newLang);
    };

    return (
        <section className="prom__layout--header">
            {isCompact ? (
                <>
                    <div className="prom__layout--header_compact-bar">
                        <img className="prom__layout--header_compact-logo" src={logo} alt="Prom-opecs logo" />
                        <IconButton aria-label="Open menu" onClick={() => setMobileOpen(true)}>
                            <MenuIcon />
                        </IconButton>
                    </div>
                    <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
                        <div className="prom-mobile-drawer">
                            <div className="prom-mobile-drawer__close">
                                <IconButton aria-label="Close menu" onClick={() => setMobileOpen(false)}>
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <div className="prom-mobile-drawer__nav" onClick={() => setMobileOpen(false)}>
                                <Menu />
                            </div>
                            <div className="prom-mobile-drawer__contact">
                                <ContactInfo />
                            </div>
                            <LanguageSwitch onLangChange={handleLangChange} />
                        </div>
                    </Drawer>
                </>
            ) : (
                <>
                    <TopBar onLangChange={handleLangChange} />
                    <Menu />
                </>
            )}
        </section>
    )
};

export default Header
